import { render, staticRenderFns } from "./tempNotice.vue?vue&type=template&id=7f3679de&scoped=true&"
import script from "./tempNotice.vue?vue&type=script&lang=js&"
export * from "./tempNotice.vue?vue&type=script&lang=js&"
import style0 from "./tempNotice.vue?vue&type=style&index=0&id=7f3679de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3679de",
  null
  
)

export default component.exports